<template lang="pug">
  #app(
    :class="{ hasHover: !isMobile, mobile: isMobile }"
  )
    Navigation(v-if="showNavigation")
    KeepAlive(include="WorksMobile")
      RouterView.view
</template>

<script>
import { isMobile } from '@/utils'
import Navigation from '@/components/Navigation'

export default {
  components: {
    Navigation
  },

  data() {
    return {
      isMobile: false
    }
  },

  computed: {
    showNavigation() {
      const { showNavigation } = this.$route.meta
      return showNavigation === undefined || showNavigation
    }
  },

  created() {
    this.isMobile = isMobile()
  }
}
</script>

<style lang="scss">
@import '~@/settings';

* {
  box-sizing: border-box;
}

.light-on-dark {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body,
html {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}

html {
  font-family: arial, sans-serif;
  font-size: 20px;
}

#app {
  display: flex;
  flex-direction: column;
  height: 100%;
  font-size: 14px;
}

.view {
  flex: 1;
}
</style>
